import React, { useRef, useState } from 'react';
import { noop } from 'lodash';

import ElearningTestFeature from '@features/elearning-test';
import VideoFeature from '@features/video';
import {
  useExternalElearningElearningAccept,
  useExternalElearningFinish,
  useExternalElearningSubmitTest,
  useExternalElearningTestQuery
} from '@services/elearning-external';
import { useVismaConfiguration } from '@services/visitor-management';

import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@constants/routes';
import { useExternalElearningFlow } from './shared/eel-flow-context';

function ExternalElearningTestSection() {
  const { data: questions, isLoading: isLoadingQuestions } =
    useExternalElearningTestQuery();
  const submitMutation = useExternalElearningSubmitTest();
  const finishMutation = useExternalElearningFinish();
  return (
    <ElearningTestFeature
      questions={questions ?? []}
      isLoading={
        isLoadingQuestions ||
        submitMutation.isPending ||
        finishMutation.isPending
      }
      onSubmit={(testAnswers) => submitMutation.mutateAsync({ testAnswers })}
      onNext={() => finishMutation.mutateAsync().catch(noop)}
    />
  );
}

function ExternalElearningVideoPage() {
  const { goBack } = useExternalElearningFlow();
  const { configuration } = useVismaConfiguration();
  const hasTest =
    configuration?.elearningTestData?.compliance_test_has === 'yes';
  const [videoAccepted, setVideoAccepted] = useState(false);
  const acceptMutation = useExternalElearningElearningAccept();
  const finishMutation = useExternalElearningFinish();
  const testSectionRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const onElearningComplete = async (accepted: boolean) => {
    await acceptMutation.mutateAsync(accepted);
    if (!accepted) {
      return navigate(ROUTES.EEL_LOGOUT);
    }
    if (!hasTest) return void finishMutation.mutateAsync().catch(noop);

    setVideoAccepted(true);
    setTimeout(() => {
      testSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  };

  return (
    <VideoFeature
      onElearningComplete={onElearningComplete}
      isLoading={acceptMutation.isPending || finishMutation.isPending}
      onPreviousPage={goBack}
    >
      {videoAccepted && (
        <div ref={testSectionRef}>
          <ExternalElearningTestSection />
        </div>
      )}
    </VideoFeature>
  );
}

export default ExternalElearningVideoPage;
